class CORE {

	constructor() {
		this.css_info = "font-size: 16px;color:red;";
		this.css = "font-size: 40px;color:#5D9733; text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;text-align:center";

		console.log('%c GetOrders.biz  ', this.css);
		console.log('%c ******* Loik Maksim DEV loikmaksim@ukr.net ****** ', this.css_info);
	}

	showloading () {

		this.hideloading();
		jQuery('body').prepend
		('<div id="loader-wrapper">' +
			'<div id="loader"></div>' +
			'<div class="loader-section section-left"></div>' +
			'<div class="loader-section section-right"></div>' +
			'</div>');
	}

	hideloading () {
		jQuery('.overlay').remove();
		jQuery('#loader-wrapper').remove();
	}

	shlide_glovo_categ(obj) {
		let child_menu = jQuery(obj).parents('dl').find('dd');
		if(child_menu.hasClass("active")) {
			child_menu.removeClass('active');
		}
		else {
			child_menu.addClass('active');
		}
	}

}
export default CORE;
